
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/page/[page]",
      function () {
        return require("private-next-pages/reviews/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/page/[page]"])
      });
    }
  